// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchForm_form__iiYi7","submit":"SearchForm_submit__1ysIi"};